module.exports = __webpack_public_path__ + "img/04-3-4跟踪记录.f1796c16.svg";